import React from "react";
import { X } from "lucide-react";

export default function PublicGenderPickerModal({
  open,
  onClose,
  onSelect,
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100000] bg-black/50 backdrop-blur-sm flex items-end sm:items-center justify-center p-0 sm:p-4">
      <div className="w-full max-w-md bg-white rounded-t-[2rem] sm:rounded-3xl shadow-2xl overflow-hidden">
        <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
          <h3 className="text-base font-black text-gray-900">
            ご利用区分をお選びください
          </h3>

          <button
            type="button"
            onClick={onClose}
            className="p-2 rounded-full bg-gray-100 text-gray-500 hover:text-gray-700 transition-colors"
            aria-label="close"
          >
            <X size={18} />
          </button>
        </div>

        <div className="p-5 space-y-5">
          <p className="text-sm text-gray-500 leading-relaxed">
            表示される商品を切り替えるために使用します
          </p>

          <div className="grid grid-cols-2 gap-3">
          <button
            type="button"
            onClick={() => onSelect("male")}
            className="w-full py-4 rounded-3xl border-2 border-gray-200 bg-white text-gray-900 font-black text-base hover:border-gray-400 active:scale-[0.98] transition-all"
          >
            男性用
          </button>

          <button
            type="button"
            onClick={() => onSelect("female")}
            className="w-full py-4 rounded-3xl border-2 border-gray-200 bg-white text-gray-900 font-black text-base hover:border-gray-400 active:scale-[0.98] transition-all"
          >
            女性用
          </button>
          </div>

          <p className="text-[11px] text-gray-500 font-medium leading-relaxed">
            この選択は表示用です。後から変更できます。
          </p>
        </div>
      </div>
    </div>
  );
}